import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=78a25d4d&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./About.scss?vue&type=style&index=0&id=78a25d4d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a25d4d",
  null
  
)

export default component.exports